<template>
  <notes
    description="General Notes related to this Restaurant"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    restaurant: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "restaurant"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.restaurant.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
